// src/services/bannerService.js

import apiService from "./apiService";

// === BANNERS ===
const getAllBanners = () => apiService.getAll("backend/banners");
const getBannerById = (id) => apiService.getById("backend/banners", id);
const createBanner = (data) => apiService.create("backend/banners", data);
const updateBanner = (id, data) =>
  apiService.updateWithFile("backend/banners", id, data);

const deleteBanner = (id) => apiService.remove("backend/banners", id);

const changeBannerStatus = (id, status) =>
  apiService.post(`backend/banners/${id}/status`, { status });

// === EXPORT ===
const bannerService = {
  getAllBanners,
  getBannerById,
  createBanner,
  updateBanner,
  deleteBanner,
  changeBannerStatus,
};

export default bannerService;
